// duration is used to calculate current position in program on mobiles
export const breaks = [
  {
    startTime: '07:30',
    duration: '75',
    groupedTalks: [{ startTime: '07:30', isBreak: true, title: 'Registrations and Breakfast' }]
  },
  {
    startTime: '10:00',
    duration: '30',
    groupedTalks: [
      {
        startTime: '10:00',
        isBreak: true,
        title: 'Networking Coffee Break, Exhibition Area'
      }
    ]
  },
  {
    startTime: '11:10',
    duration: '10',
    groupedTalks: [{ startTime: '11:10', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '12:00',
    duration: '60',
    groupedTalks: [{ startTime: '12:00', isBreak: true, title: 'Networking Lunch' }]
  },
  {
    startTime: '13:40',
    duration: '10',
    groupedTalks: [{ startTime: '13:40', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '14:30',
    duration: '30',
    groupedTalks: [
      { startTime: '14:30', isBreak: true, title: 'Expert Discussions, Exhibition Area' }
    ]
  },
  {
    startTime: '15:40',
    duration: '10',
    groupedTalks: [{ startTime: '14:40', isBreak: true, title: 'Break' }]
  },
  {
    startTime: '16:30',
    groupedTalks: [
      {
        startTime: '16:30',
        isBreak: true,
        title: 'Conference Closing: Prize Draw, Winner Announcements and Wrap-up'
      }
    ]
  }
  // {
  //   startTime: '17:20',
  //   groupedTalks: [{ startTime: '17:20', isBreak: true, title: 'Conference Closing' }]
  // }
];

export const placeholders = [
  // {
  //   startTime: '13:00',
  //   groupedTalks: [
  //     {
  //       startTime: '13:00',
  //       trackInDay: 6,
  //       title: 'Panel Discussion - details will be published soon',
  //       tileRole: 'CLOSED',
  //       id: '001'
  //     }
  //   ]
  // },
  {
    startTime: '13:50',
    groupedTalks: [
      {
        startTime: '13:50',
        trackInDay: 6,
        title: 'Panel Discussion: Navigating Autonomous AI Futures',
        tileRole: 'CLOSED',
        id: '011'
      }
    ]
  },
  {
    startTime: '15:00',
    groupedTalks: [
      // { startTime: '15:00', trackInDay: 1, title: 'Coming Soon', tileRole: 'CLOSED', id: '021' },
      // {
      //   startTime: '15:00',
      //   trackInDay: 6,
      //   title: 'KLIK podcast by SME daily - public recording (in Slovak language)',
      //   tileRole: 'CLOSED',
      //   id: '023'
      // }
    ]
  },
  {
    startTime: '15:50',
    groupedTalks: [
      { startTime: '15:50', trackInDay: 4, title: 'Closed', tileRole: 'CLOSED', id: '031' },
      { startTime: '15:50', trackInDay: 6, title: 'Closed', tileRole: 'CLOSED', id: '032' }
    ]
  }
];

export const workshopPlaceholders = [
  // {
  //   startTime: '12:00',
  //   groupedTalks: [
  //     {
  //       startTime: '12:00',
  //       trackInDay: 4,
  //       title: 'CLOSED',
  //       tileRole: 'CLOSED',
  //       id: '8'
  //     }
  //   ]
  // },
  {
    startTime: '15:00',
    groupedTalks: [
      {
        startTime: '15:00',
        trackInDay: 3,
        title: 'CLOSED',
        tileRole: 'CLOSED',
        id: '11'
      }
    ]
  }
];

export const keyNote = {
  startTime: '09:00',
  endTime: '09:30',
  trackInDay: 1,
  title: 'Keynote',
  tileRole: 'CLOSED',
  id: '3',
  room: '',
  youtube: ''
};

export const conferenceOpening = {
  startTime: '08:45',
  endTime: '09:00',
  title: 'Conference Opening',
  room: '',
  track: 'Talk',
  isConferenceOpening: true,
  youtube: '',
  speakers: [
    // { id: '1', name: 'Tomas Volek', company: 'Accenture', country: 'Slovakia' }
  ],
  trackInDay: 1
};

export default {
  breaks,
  placeholders,
  conferenceOpening,
  workshopPlaceholders
};
